export default {
  states: [
    { value: 'Alabama', text: 'Alabama' },
    { value: 'Alaska', text: 'Alaska' },
    { value: 'Arizona', text: 'Arizona' },
    { value: 'Arkansas', text: 'Arkansas' },
    { value: 'California', text: 'California' },
    { value: 'Colorado', text: 'Colorado' },
    { value: 'Connecticut', text: 'Connecticut' },
    { value: 'Delaware', text: 'Delaware' },
    { value: 'Florida', text: 'Florida' },
    { value: 'Georgia', text: 'Georgia' },
    { value: 'Hawaii', text: 'Hawaii' },
    { value: 'Idaho', text: 'Idaho' },
    { value: 'Illinois', text: 'Illinois' },
    { value: 'Indiana', text: 'Indiana' },
    { value: 'Iowa', text: 'Iowa' },
    { value: 'Kansas', text: 'Kansas' },
    { value: 'Kentucky', text: 'Kentucky' },
    { value: 'Louisiana', text: 'Louisiana' },
    { value: 'Maine', text: 'Maine' },
    { value: 'Maryland', text: 'Maryland' },
    { value: 'Massachusetts', text: 'Massachusetts' },
    { value: 'Michigan', text: 'Michigan' },
    { value: 'Minnesota', text: 'Minnesota' },
    { value: 'Mississippi', text: 'Mississippi' },
    { value: 'Missouri', text: 'Missouri' },
    { value: 'Montana', text: 'Montana' },
    { value: 'Nebraska', text: 'Nebraska' },
    { value: 'Nevada', text: 'Nevada' },
    { value: 'New Hampshire', text: 'New Hampshire' },
    { value: 'New Jersey', text: 'New Jersey' },
    { value: 'New Mexico', text: 'New Mexico' },
    { value: 'New York', text: 'New York' },
    { value: 'North Carolina', text: 'North Carolina' },
    { value: 'North Dakota', text: 'North Dakota' },
    { value: 'Ohio', text: 'Ohio' },
    { value: 'Oklahoma', text: 'Oklahoma' },
    { value: 'Oregon', text: 'Oregon' },
    { value: 'Pennsylvania', text: 'Pennsylvania' },
    { value: 'Rhode Island', text: 'Rhode Island' },
    { value: 'South Carolina', text: 'South Carolina' },
    { value: 'South Dakota', text: 'South Dakota' },
    { value: 'Tennessee', text: 'Tennessee' },
    { value: 'Texas', text: 'Texas' },
    { value: 'Utah', text: 'Utah' },
    { value: 'Vermont', text: 'Vermont' },
    { value: 'Virginia', text: 'Virginia' },
    { value: 'Washington', text: 'Washington' },
    { value: 'West Virginia', text: 'West Virginia' },
    { value: 'Wisconsin', text: 'Wisconsin' },
    { value: 'Wyoming', text: 'Wyoming' }
  ],
  industries: [
    {
      value:'Agriculture - Farming & Livestock',
      text:'Agriculture - Farming & Livestock'
    },
    {
      value:'Consumer Discretionary - Automotive',
      text:'Consumer Discretionary - Automotive'
    },
    {
      value:'Consumer Discretionary - Bars & Restaurants',
      text:'Consumer Discretionary - Bars & Restaurants'
    },
    {
      value:'Consumer Discretionary - DTC',
      text:'Consumer Discretionary - DTC'
    },
    {
      value:'Consumer Discretionary - Homebuilding',
      text:'Consumer Discretionary - Homebuilding'
    },
    {
      value:'Consumer Discretionary - Hospitality',
      text:'Consumer Discretionary - Hospitality'
    },
    {
      value:'Consumer Discretionary - Leisure',
      text:'Consumer Discretionary - Leisure'
    },
    {
      value:'Consumer Discretionary - Media',
      text:'Consumer Discretionary - Media'
    },
    {
      value:'Consumer Discretionary - Non-traditional Food',
      text:'Consumer Discretionary - Non-traditional Food'
    },
    {
      value:'Consumer Discretionary - Private Passenger Transportation',
      text:'Consumer Discretionary - Private Passenger Transportation'
    },
    {
      value:'Consumer Discretionary - Services',
      text:'Consumer Discretionary - Services'
    },
    {
      value:'Consumer Staples - Food & Beverages',
      text:'Consumer Staples - Food & Beverages'
    },
    {
      value:'Consumer Staples - Non-durable Goods',
      text:'Consumer Staples - Non-durable Goods'
    },
    {
      value:'Consumer Staples - Public Passenger Transportation',
      text:'Consumer Staples - Public Passenger Transportation'
    },
    {
      value:'Energy - Coal & Consumables',
      text:'Energy - Coal & Consumables'
    },
    {
      value:'Energy - Oil & Gas',
      text:'Energy - Oil & Gas'
    },
    {
      value:'Energy - Renewables',
      text:'Energy - Renewables'
    },
    {
      value:'Financial Services - Diversified',
      text:'Financial Services - Diversified'
    },
    {
      value:'Financial Services - Non-traditional',
      text:'Financial Services - Non-traditional'
    },
    {
      value:'Health Care - Equipment Manufacturing',
      text:'Health Care - Equipment Manufacturing'
    },
    {
      value:'Health Care - Life Sciences',
      text:'Health Care - Life Sciences'
    },
    {
      value:'Health Care - Services',
      text:'Health Care - Services'
    },
    {
      value:'Industrial - Aerospace & Defense',
      text:'Industrial - Aerospace & Defense'
    },
    {
      value:'Industrial- Commercial Printing',
      text:'Industrial- Commercial Printing'
    },
    {
      value:'Industrial - Construction Services',
      text:'Industrial - Construction Services'
    },
    {
      value:'Industrial - Distribution and Logistics',
      text:'Industrial - Distribution and Logistics'
    },
    {
      value:'Industrial - Diversified Manufacturing',
      text:'Industrial - Diversified Manufacturing'
    },
    {
      value:'Industrial - Electrical Components',
      text:'Industrial - Electrical Components'
    },
    {
      value:'Industrial - Environmental & Facilities Services',
      text:'Industrial - Environmental & Facilities Services'
    },
    {
      value:'Industrial - Industrial Transportation',
      text:'Industrial - Industrial Transportation'
    },
    {
      value:'Industrial - Long-haul Transportation',
      text:'Industrial - Long-haul Transportation'
    },
    {
      value:'Industrial - Machinery and Equipment',
      text:'Industrial - Machinery and Equipment'
    },
    {
      value:'Industrial - Short-haul Transportation',
      text:'Industrial - Short-haul Transportation'
    },
    {
      value:'Infrastructure - Ground',
      text:'Infrastructure - Ground'
    },
    {
      value:'Infrastructure - Utilities',
      text:'Infrastructure - Utilities'
    },
    {
      value:'Materials - Chemical Products',
      text:'Materials - Chemical Products'
    },
    {
      value:'Materials - Construction Products',
      text:'Materials - Construction Products'
    },
    {
      value:'Materials - Forest Products',
      text:'Materials - Forest Products'
    },
    {
      value:'Materials - Metals & Mining',
      text:'Materials - Metals & Mining'
    },
    {
      value:'Materials - Non-metal Recycling',
      text:'Materials - Non-metal Recycling'
    },
    {
      value:'Materials - Precious Metals',
      text:'Materials - Precious Metals'
    },
    {
      value:'Technology - Commercial Services',
      text:'Technology - Commercial Services'
    },
    {
      value:'Technology - Equipment Manufacturing',
      text:'Technology - Equipment Manufacturing'
    },
    {
      value:'Technology - IT Services',
      text:'Technology - IT Services'
    },
    {
      value:'Technology - Network Operators',
      text:'Technology - Network Operators'
    }
  ],
  structures: [
    { value: 'C corp', text: 'C corp' },
    { value: 'Federal Government', text: 'Federal Government' },
    {
      value: 'Limited Liability Partnership',
      text: 'Limited Liability Partnership'
    },
    {
      value: 'Limited Liability Limited Partnership',
      text: 'Limited Liability Limited Partnership'
    },
    { value: 'LLC', text: 'LLC' },
    { value: 'Non Profit', text: 'Non Profit' },
    { value: 'Partnership', text: 'Partnership' },
    {
      value: 'Professional Corporation',
      text: 'Professional Corporation'
    },
    { value: 'S Corp', text: 'S Corp' },
    { value: 'Sole Prop', text: 'Sole Prop' },
    { value: 'State/Local Government', text: 'State/Local Government' },
    { value: 'Other', text: 'Other' }
  ],
  downPaymentOrNot: [
    {
      value: true,
      text: 'Yes'
    },
    {
      value: false,
      text: 'No'
    }
  ],
  reasonsForEquipment: [
    { value: 'Business Growth', text: 'Business Growth' },
    { value: 'Starting New Business', text: 'Starting New Business' },
    { value: 'Refinancing', text: 'Refinancing' },
    { value: 'Replacement', text: 'Replacement' }
  ],
  equipmentTypes: [
    { value: 'Agriculture', text: 'Agriculture' },
    { value: 'Air Transportation', text: 'Air Transportation' },
    { value: 'Automotive', text: 'Automotive' },
    { value: 'Building Automation', text: 'Building Automation' },
    { value: 'Commercial', text: 'Commercial' },
    { value: 'Construction', text: 'Construction' },
    { value: 'Fitness & Spa', text: 'Fitness & Spa' },
    { value: 'Food Service', text: 'Food Service' },
    { value: 'Intermodal', text: 'Intermodal' },
    { value: 'Landscaping', text: 'Landscaping' },
    { value: 'Logging', text: 'Logging' },
    { value: 'Manufacturing', text: 'Manufacturing' },
    { value: 'Marine Transportation', text: 'Marine Transportation' },
    { value: 'Material Handling', text: 'Material Handling' },
    { value: 'Medical', text: 'Medical' },
    { value: 'Packaging', text: 'Packaging' },
    { value: 'Printing', text: 'Printing' },
    { value: 'Rail Transportation', text: 'Rail Transportation' },
    { value: 'Software', text: 'Software' },
    { value: 'Technology - A/V', text: 'Technology - A/V' },
    { value: 'Technology - Commercial', text: 'Technology - Commercial' },
    {
      value: 'Technology - Infrastructure',
      text: 'Technology - Infrastructure'
    },
    { value: 'Trailer - OTR', text: 'Trailer - OTR' },
    { value: 'Trailer - Vocational', text: 'Trailer - Vocational' },
    { value: 'Truck - OTR', text: 'Truck - OTR' },
    { value: 'Truck - Vocational', text: 'Truck - Vocational' },
    { value: 'XX Accessories', text: 'XX Accessories' }
  ],
  status: [
    {
      value: "New",
      text: "New"
    },
    {
      value: "Used",
      text: "Used"
    }
  ],
  quoteTable: {
    Fair: [47.3, 49.67, 33.45, 35.12, 26.58, 27.9, 22.49, 23.62, 19.53, 20.51, 17.63, 18.51],
    Good: [45.61, 47.89, 31.73, 33.31, 24.49, 25.71, 20.16, 21.16, 17.28, 18.14, 15.32, 16.09],
    Great: [44.61, 46.84, 30.71, 32.24, 23.62, 24.8, 19.37, 20.34, 16.54, 17.37, 14.58, 15.31],
    Excellent: [44.01, 46.21, 30.11, 31.62, 23.03, 24.18, 18.78, 19.72, 15.95, 16.75, 13.98, 14.68]
  }
}


// WEBPACK FOOTER //
// ./src/constant/common.js